import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {EarnedCertification} from "../models/earned-certification";
import {PageQueryInterface} from "../../../_models/page.interface";
import {a} from "@fullcalendar/core/internal-common";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private USER_API: string;
  private FILE_API: string;
  constructor(private http: HttpClient) {
    this.USER_API = `${environment.apiUrl}/user/`;
    this.FILE_API = `${environment.apiUrl}/file/`;
  }



  async getUserInfo(email: string): Promise<any> {
    return await this.http.get(this.USER_API + `get-current-user`).toPromise();
  }

  async updateProfile(user: any): Promise<any> {
    return await this.http.post(this.USER_API + 'update-profile', user, httpOptions).toPromise();
  }

  async updateSettings(user: any): Promise<any> {
    return await this.http.post(this.USER_API + 'update-settings', user, httpOptions).toPromise();
  }

  async emailAgent(email: any): Promise<any> {
    return await this.http.post(this.USER_API + 'email-agent', email, httpOptions).toPromise();
  }

  async enrollMe(ceuId: string): Promise<any> {
    return await this.http.post(this.USER_API + 'enroll-me/'+ceuId, {}).toPromise();
  }

  async delete(id: string): Promise<any> {
    return await this.http.delete(`${environment.apiUrl}/users/${id}`).toPromise();
  }

  async addCertification(cert: any): Promise<any> {
    return await this.http.post(this.USER_API + 'add-certification', cert).toPromise();
  }

  async updateCertification(cert: any): Promise<any> {
    return await this.http.post(this.USER_API + 'update-certification', cert).toPromise();
  }

  async deleteCertification(cert: any): Promise<any> {
    return await this.http.post(this.USER_API + 'delete-certification', cert).toPromise();
  }

  async getUserCertifications(pageQuery: PageQueryInterface): Promise<any> {
    return await this.http.post(this.USER_API + `get-user-certifications`, pageQuery).toPromise();
  }

  async getUserCertificationList(): Promise<any> {
    return await this.http.get(this.USER_API + `get-user-certifications`).toPromise();
  }

  async getUserCEUs(pageQuery: PageQueryInterface): Promise<any> {
    return await this.http.post(this.USER_API + `get-user-ceus/v2`, pageQuery).toPromise();
  }

  async getUserCEUById(documentId: number): Promise<any> {
    return await this.http.get(this.USER_API + `get-user-ceus/${documentId}`).toPromise();
  }

  async getUserTranscript(): Promise<any> {
    return await this.http.get(this.FILE_API + `pdf/transcript`, {
      responseType: 'blob',
    }).toPromise();
  }
  async setNotNewUser(): Promise<any> {
    return await this.http.post<any>(this.USER_API + 'set-not-new-user', {}).toPromise();
  }

  async setTourDone(): Promise<any> {
    return await this.http.post<any>(this.USER_API + 'set-tour-done', {}).toPromise();
  }

  async uploadFileAttachment(fd: FormData, id: number): Promise<any> {
    return await this.http.post<any>(`${this.FILE_API}upload-attachment?id=${id}`, fd, {}).toPromise();
  }

  async saveValidationCheck(payload: any): Promise<any> {
    return await this.http.post<any>(this.USER_API + `save-validation-check`, payload).toPromise();
  }

  async uploadFile(fd: FormData, certificationId: number, documentType: string, providerActivityId: number, validationCheck: any): Promise<any> {
    fd.append("validationCheck", new Blob([JSON.stringify(validationCheck)], { type: "application/json" }));

    return await this.http.post<any>(`${this.FILE_API}upload-cert?certificationId=${certificationId}&documentType=${documentType}&activityId=${providerActivityId}`, fd, {}).toPromise();
  }

  async updateFile(fd: FormData, documentId: number, certificationId: number,  documentType: string, providerActivityId: number, validationCheck: any): Promise<any> {
    fd.append("validationCheck", new Blob([JSON.stringify(validationCheck)], { type: "application/json" }));
    return await this.http.post<any>(`${this.FILE_API}update-cert?documentId=${documentId}&certificationId=${certificationId}&documentType=${documentType}&activityId=${providerActivityId}`, fd, {}).toPromise();
  }

  async updateNotification(id: number): Promise<any> {
    return await this.http.get<any>(`${this.USER_API}mark-as-read-notification/${id}`).toPromise();
  }

  async openWalletSupportTicket(name: string, email: string, subject: string, message: string): Promise<any> {
    return await this.http.post<any>(this.USER_API + 'new-wallet-support-ticket', {
      name: name,
      email: email,
      subject: subject,
      message: message
    }).toPromise();
  }

  async replyWalletSupportTicket(message: string, walletSupportId: number, hasAttachment: boolean): Promise<any> {
    return await this.http.post<any>(this.USER_API + 'reply-wallet-support-ticket', {
      message: message,
      walletSupportId: walletSupportId,
      hasAttachment: hasAttachment,
    }).toPromise();
  }

  async getWalletSupport(pageQuery: PageQueryInterface): Promise<any> {
    return await this.http.post(this.USER_API + `get-wallet-supports`, pageQuery).toPromise();
  }

  async getWalletSupportDetails(id: number): Promise<any> {
    return await this.http.get(this.USER_API + `wallet-supports/${id}`).toPromise();
  }
}
